import { ICFS } from './cfs';
import { IFile } from './file';
import { IKase } from './kase';

// User stub for populated user references
export interface IIACaseUserStub {
  _id: string;
  firstName?: string;
  lastName?: string;
  fullName?: string;
  email?: string;
}

export enum IACaseType {
  USE_OF_FORCE = 'USE_OF_FORCE',
  OFFICER_MISCONDUCT = 'OFFICER_MISCONDUCT',
  CITIZEN_COMPLAINT = 'CITIZEN_COMPLAINT',
  INTERNAL_COMPLAINT = 'INTERNAL_COMPLAINT',
  POLICY_VIOLATION = 'POLICY_VIOLATION',
}

export enum IACaseStatus {
  OPEN = 'OPEN',
  IN_PROGRESS = 'IN_PROGRESS',
  CLOSED = 'CLOSED',
}

export interface IIACaseRelatedRecord {
  recordType: 'CFS' | 'KASE';
  recordId: string;
}

export interface IIACaseDeletionInfo {
  deletedBy: string;
  deletedAt: string;
  reason: string;
}

export interface IIACase {
  _id: string;
  caseId: string;
  agency: string;
  caseType: IACaseType;
  caseDetails: string;
  officerDetails: string;
  status: IACaseStatus;
  investigationNotes?: string | null;
  findingsAndRecommendations?: string | null;
  files?: IFile[] | null;
  // Related records are now fetched via junction tables
  relatedCase?: IKase[] | null;
  relatedCfs?: ICFS[] | null;
  assignedOfficers: (string | IIACaseUserStub)[];
  caseOwner: string | IIACaseUserStub;
  createdBy: string | IIACaseUserStub;
  deletionInfo?: IIACaseDeletionInfo | null;
  createdAt: string;
  updatedAt: string;
}

export interface IIACaseCreateRequest {
  caseType: IACaseType;
  caseDetails: string;
  officerDetails: string;
  investigationNotes?: string;
  findingsAndRecommendations?: string;
  assignedOfficers?: string[];
}

export interface IIACaseUpdateRequest {
  caseType?: IACaseType;
  caseDetails?: string;
  officerDetails?: string;
  status?: IACaseStatus;
  investigationNotes?: string;
  findingsAndRecommendations?: string;
}

export interface IIACaseReportResponse {
  title: string;
  generatedAt: string;
  filters: string;
  totalCases: number;
  statusDistribution: Array<{
    status: string;
    count: number;
    percentage: number;
  }>;
  cases: Array<{
    caseId: string;
    caseType: string;
    status: string;
    caseOwner: string;
    createdBy: string;
    createdAt: string;
    updatedAt: string;
  }>;
  format: 'pdf' | 'csv';
}
